import { Box, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { ReferralProgram } from "../types/view.referral";
import { fallback } from "../utils/formatters";
import ButtonIcon from "../../../components/icons/PenPaperIcon";

interface Props {
  data: ReferralProgram;
}

const rowSx = {
  display: "grid",
  gridTemplateColumns: "160px 1fr",
  gap: 2,
  py: 1.4,
  borderBottom: "1px solid #E8ECF1",
};

export default function ReferralInfoCard({ data }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "20px",
        p: 2.5,
        backgroundColor: colors.primary[900],
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
          Partner Information
        </Typography>

        <IconButton size="small">
          <ButtonIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={rowSx}>
        <Typography sx={{ color: "#98A3B3" }}>Email</Typography>
        <Typography sx={{ color: "#4E5969" }}>
          {fallback(data.email)}
        </Typography>
      </Box>

      <Box sx={rowSx}>
        <Typography sx={{ color: "#98A3B3" }}>Phone Number</Typography>
        <Typography sx={{ color: "#4E5969" }}>
          {fallback(data.phone_number)}
        </Typography>
      </Box>

      <Box sx={rowSx}>
        <Typography sx={{ color: "#98A3B3" }}>Address</Typography>
        <Typography sx={{ color: "#4E5969" }}>
          {fallback(data.address)}
        </Typography>
      </Box>

      <Box sx={rowSx}>
        <Typography sx={{ color: "#98A3B3" }}>Payment</Typography>
        <Typography sx={{ color: "#4E5969" }}>
          {fallback(data.payment_method)}
        </Typography>
      </Box>

      <Box sx={{ ...rowSx, borderBottom: "none" }}>
        <Typography sx={{ color: "#98A3B3" }}>Commission Rate</Typography>
        <Typography sx={{ color: "#4E5969" }}>
          {data.commission_rate !== null && data.commission_rate !== undefined
            ? `${data.commission_rate}%`
            : "N/A"}
        </Typography>
      </Box>
    </Paper>
  );
}
